<template>
  <div style="max-height: 65vh; overflow-y: auto" class="pa-3">
    <v-expansion-panels multiple  v-if="oneClient != null" v-model="panel">

      <v-expansion-panel  style="border-bottom: solid #ddd 1px;" ripple>
        <v-expansion-panel-header class="red--text font-weight-bold">Negociações</v-expansion-panel-header>
        <v-expansion-panel-content>
          <list-deals></list-deals>
        </v-expansion-panel-content>
      </v-expansion-panel>

      <v-expansion-panel  style="border-bottom: solid #ddd 1px;" ripple>
        <v-expansion-panel-header class="red--text font-weight-bold">Pedidos</v-expansion-panel-header>
        <v-expansion-panel-content>
          <list-orders></list-orders>
        </v-expansion-panel-content>
      </v-expansion-panel>

    </v-expansion-panels>

  </div>
</template>

<script>
import { mapActions, mapState, } from 'vuex'

export default {
  components: {
    ListDeals: () => import('@/_backoffice/_registrations/components/client/deals/deals.vue'),
    ListOrders: () => import('./ClientProfileOrders.vue'),
  },
  data() {
    return {
      key: null,
      panel: [0,1],

    }
  },
  computed: {
    ...mapState({
      oneClient: state => state.Client.oneClient,
      // data: state=> state.Module.state_var
    })
  },
}
</script>
